export default __webpack_public_path__ + "static/media/priority_processing.44a0b743.svg";